import { Can } from 'providers/casl'
import { onFinanceAccess } from '../features/finance'
import { onLayoutAccess } from '../features/layout'
import {
  onPerformanceRichPlacementProductAccess,
  onPerformanceYieldbirdDemandAccess,
} from '../features/performance'
import { onTagAccess } from '../features/tag'

export const onFinancialViewer = (can: Can) => {
  onFinanceAccess(can)
  onLayoutAccess(can)
  onPerformanceRichPlacementProductAccess(can)
  onPerformanceYieldbirdDemandAccess(can)
  onTagAccess(can)
}
